import { createAsyncThunk } from "@reduxjs/toolkit";
import { Base_URL, ApiCall } from "../../Common/Path";

//Transaction Calls

export const TransactionTable = createAsyncThunk(
  "TransactionTable",
  async () => {
    try {
      const response = await ApiCall(
        `${Base_URL}/allTransfers`, '', 'get'
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const TransactionStatusChange = createAsyncThunk(
  "TransactionStatusChange",
  async ({ id, status }) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/transfer-status/${id}/${status}`,
        '', "PATCH"
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

//Get Strategy
export const GetStrategy = createAsyncThunk("GetStrategy", async (id) => {
  try {
    const response = await ApiCall(
      `${Base_URL}/transaction/strategy/${id}/variance`, '', 'get'
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const Getwaytransactions = createAsyncThunk("Getwaytransactions", async (body) => {
  try {
    const response = await ApiCall(`${Base_URL}/transaction/custodian-transactions/${body?.userId}/${body?.custodianId}/${body?.type}`, '', 'get');
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const AddibkrAssets = createAsyncThunk("AddibkrAssets", async ({payload, id}) => {
  try {
    const response = await ApiCall(`${Base_URL}/assets/${id}`, payload, "post");
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});
